<template>
  <div>
    <v-card color="#EDF1F3">
      <v-layout align-center justify-start style="padding-inline-start: 20px">
        <v-flex xs1> </v-flex>
        <v-flex xs8>
          <div>
            <div class="headline">{{ this.event.name }}</div>
            <div style="color: #8599a3">
              {{ $t("planningPage.lastTimeToApply") }}:
              {{
                $companyTime(event.last_appliance_date, " DD MMM YYYY")
              }}
            </div>
            <div style="color: #8599a3; margin-top: 6px">
              {{ $companyTime(event.start_date, " DD MMM YYYY") }} -
              {{ $companyTime(event.end_date, " DD MMM YYYY") }}
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-card>
    <v-dialog
      v-model="captain_details_dialog"
      v-if="captain_details_dialog == true"
    >
      <v-card>
        <v-container>
          <DataTable
            :url="api.ACTIONS.EVENTS_DETAILS_CAPTAINS(this.event_details_id)"
            :titles="titles_details"
            :fields-hidden-main="[
              'pending_transfer_request_id',
              'can_see_booking_price',
              'only_accepts_bookings_from_suggestions',
              'can_change_auto_accept',
              'pending_transfer_request_timer',
              'car',
              'cars',
              'deleted_at',
              'updated_at',
              'created_at',
              'event_details_id',
            ]"
            :disableSearch="true"
            :title="$t('planningPage.captainsAppliedToShift')"
            :enableEdit="false"
            :enableAdd="false"
            :enableDelete="false"
          />
        </v-container>
      </v-card>
    </v-dialog>
    <v-card class="card-info">
      <DataTable
        :url="api.ACTIONS.EVENTS_DETAILS(this.$route.params.id)"
        :titles="titles"
        :fields-hidden-main="[
          'deleted_at',
          'updated_at',
          'created_at',
          'event_id',
        ]"
        :disableSearch="true"
        :title="$t('planningPage.eventsDetails')"
        sortBy="start_date"
        :enableEdit="false"
        :enableAdd="false"
        :enableDelete="false"
        :actions-extra-main="actionsExtraMain"
      />
    </v-card>
  </div>
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
import LoadingComponent from "@/components/LoadingComponent";

export default {
  name: "EventDetails",
  title() {
    return this.$t("planningPage.eventDetailsTitle");
  },
  components: {
    LoadingComponent,
    DataTable,
  },

  data() {
    return {
      event: "",
      loading: false,
      captain_details_dialog: false,
      event_details_id: null,
    };
  },
  mounted() {
    this.axios.get(`event/${this.$route.params.id}`).then(({ data }) => {
      this.event = data.data;
      this.loading = false;
    });
  },

  computed: {
    titles() {
      return {
        id: this.$t("planningPage.id"),
        shift_start: this.$t("planningPage.startShiftDate"),
        shift_end: this.$t("planningPage.endShiftDate"),
        captain_count: this.$t("planningPage.captainCount"),
      };
    },
    titles_details() {
      return {
        id: this.$t("planningPage.id"),
        captain_name: this.$t("planningPage.captainName"),
        apply_date: this.$t("planningPage.applyDate"),
      };
    },
    actionsExtraMain() {
      return {
        info: {
          title: this.$t("planningPage.info"),
          icon: "info",
          action: (item) => {
            this.event_details_id = item.id;
            this.captain_details_dialog = true;
          },
        },
      };
    },
  },
};
</script>

<style scoped>
.car {
  color: #7e939c;
}
.image {
  border-radius: 100%;
  height: 100px;
  width: 100px;
  margin-inline-end: 17px;
  margin-top: 10px;
}
.image:hover {
  background-color: black;
  opacity: 0.5;
  border-radius: 100%;
  cursor: pointer;
}
.card-info {
  height: 100%;
  position: absolute;
  width: 100%;
}
</style>
